import React from "react";
import { BadgeCheckIcon, QuoteIcon, StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Testimonials() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-263" data-mp="3mgipq4m9u9xc">
      <div className="mx-auto max-w-5xl" data-id="element-264" data-mp="3mez9uf4j20w3">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-265" data-mp="3r7sj9gaxxxei">
          What other <span className="italic text-teal" data-id="element-266" data-mp="oaafv8k13g">professionals</span> are saying
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-267" data-mp="41hzdckezlxx">
          <div className="flex text-amber-500" aria-hidden="true" data-id="element-268" data-mp="91e4xg8rflfl">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" data-id="element-269" data-mp="dzxnr7s24h3q" data-mpi={i} />)}
          </div>
          <span className="text-lg font-extrabold text-navy" data-id="element-270" data-mp="2auando501q9q">4.9/5</span>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-271" data-mp="2frkb8zcqptvg">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(11,27,46,0.35)]" data-id="element-272" data-mp="1skstpymut4q4">
              <QuoteIcon className="h-8 w-8 text-teal-light" aria-hidden="true" data-id="element-273" data-mp="1ns9i377q8jny" />
              <blockquote className="mt-3 flex-1 font-serif text-xl font-bold leading-snug text-navy" data-id="element-274" data-mp="1ivre49k80pco">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-4 border-t border-cream-dark pt-5" data-id="element-275" data-mp="1euz6tluwsuj1">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-teal-soft" loading="lazy" data-id="element-276" data-mp="2bivf83g70jj6" />
                <div className="min-w-0" data-id="element-277" data-mp="22igp8qsaag9c">
                  <p className="flex items-center gap-1.5 font-bold text-ink" data-id="element-278" data-mp="22hdxyhr1ubsw">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 shrink-0 text-teal" aria-label="Verified customer" data-id="element-279" data-mp="1xj4204xi3768" />
                  </p>
                  <p className="text-sm text-ink-muted" data-id="element-280" data-mp="r17a2gg6uadu">
                    {t.role} · {t.country}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <CtaButton label="I want the same structure for my cases" className="mt-10" data-id="element-281" data-mp="skpcwp8dtbhh" />
      </div>
    </section>;
}